import React from "react";

import { EntityPin } from "@mapmycustomers/shared/types/map";

import IRecordStylingContext from "../types/IRecordStylingContext";

const RecordStylingContext = React.createContext<IRecordStylingContext>({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getPinStyle: (entityPin: EntityPin) => ({}),
});

export default RecordStylingContext;
